import { useEffect, useState } from 'react'
import { USER_TYPE_ORGANIZATION } from '../../../../constants/constants';
import { getDashboardCountsForOrg, getDashboardCountsForPartner } from '../../../../API/endpoints/Dashboard';
import { Spin } from 'antd';
import { io, Socket } from 'socket.io-client';

let socket: Socket;

interface Props {
    userProfile: any
}
const DashboardCounts = (props: Props) => {
    const { userProfile } = props;
    const [counts, setCounts] = useState<any>({
        partnerEngagement: 0,
        partnerRequests: 0,
        unreadMessages: 0,
        brandsMatched: 0,
        openOpportunities: 0
    });
    const [taskCounts, setTaskCounts] = useState(0)

    const [loadingCounts, setLoadingCounts] = useState(true);



    useEffect(() => {
        if (userProfile?.user_type === USER_TYPE_ORGANIZATION) {

            setLoadingCounts(true);
            getDashboardCountsForOrg(userProfile?.org_id, userProfile?.id).then((res: any) => {
                setCounts({
                    partnerEngagement: res?.partnerEngagement || 0,
                    partnerRequests: res?.partnerRequests || 0,
                    unreadMessages: res?.unreadMessagesCount || 0
                });
                setTaskCounts(res?.taskCount || 0);
                setLoadingCounts(false);
            }).catch((err) => {
                console.error('err', err);
                setLoadingCounts(false);
            })
        } else {
            if (userProfile?.partnerv2_id) {
                setLoadingCounts(true);
                getDashboardCountsForPartner(userProfile?.partnerv2_id, userProfile?.id).then((res: any) => {
                    setCounts({
                        brandsMatched: res?.brandsMatched || 0,
                        unreadMessages: res?.unreadMessagesCount || 0,
                        openOpportunities: res?.suitableBrandsCount || 0
                    });
                    setTaskCounts(res?.tasksCount || 0);
                    setLoadingCounts(false);
                }).catch((err) => {
                    console.error('err', err);
                    setLoadingCounts(false);
                })
            }
        }

    }, [userProfile]);


    useEffect(() => {
        socket = io(process.env.REACT_APP_API_URL_SOCKET || "http://localhost:3001", { path: "/aeg" });

        socket.on("connect", () => {
            console.log("Connected:", socket.id);
        });

        if (userProfile?.id) {
            socket.emit("register-user", userProfile?.id);
        }

        if (userProfile?.partnerv2_id) {
            socket.emit("connect-partner-user", userProfile?.id, userProfile?.partnerv2_id);
            socket.emit("get-partner-task-count", { userId: userProfile?.id, partnerId: userProfile?.partnerv2_id });

            socket.on("partner-task-count", (data: any) => {

                setTaskCounts(data?.tasksCount || 0);
            });
        }

        if (userProfile?.org_id) {
            socket.emit("connect-org-user", userProfile?.id, userProfile?.org_id);
            socket.emit("get-org-task-count", { userId: userProfile?.id, orgId: userProfile?.org_id });

            socket.on("org-task-count", (data: any) => {
                setTaskCounts(data?.tasks || 0);
            });

        }

        return () => {
            socket.disconnect();
        };
    }, [userProfile]);

    return (
        <div className="grid grid-cols-2 gap-[12px]">
            <div className="bg-white rounded-[8px] p-[10px] h-[58px]">
                {loadingCounts ? <Spin size="small" /> : <p className="text-[14px] font-bold text-[#175CD3] mb-2">{(counts?.partnerRequests || counts?.openOpportunities || 0)?.toString().padStart(2, "0")}</p>}
                <p className="text-[12px] text-[#667085] m-0 !mt-[6px]">{!userProfile?.id ? "-" : userProfile?.partnerv2_id ? "Open Opportunities" : "Partner Requests"}</p>
            </div>
            <div className="bg-white rounded-[8px] p-[10px] h-[58px]">
                {loadingCounts ? <Spin size="small" /> : <p className="text-[14px] font-bold text-[#027A48] mb-2">{(counts?.partnerEngagement || counts?.brandsMatched || 0)?.toString().padStart(2, "0")}</p>}
                <p className="text-[12px] text-[#667085] m-0  !mt-[6px]">{!userProfile?.id ? "-" : userProfile?.partnerv2_id ? "Brands Matched" : "Partner Engagement"}</p>
            </div>
            <div className="bg-white rounded-[8px] p-[10px] h-[58px]">
                {loadingCounts ? <Spin size="small" /> : <p className="text-[14px] font-bold text-[#DC6803] mb-2">{taskCounts?.toString().padStart(2, "0")}</p>}
                <p className="text-[12px] text-[#667085] m-0  !mt-[6px]">Pending Tasks</p>
            </div>
            <div className="bg-white rounded-[8px] p-[10px] h-[58px]">
                {loadingCounts ? <Spin size="small" /> : <p className="text-[14px] font-bold text-[#9810FA] mb-2">{counts?.unreadMessages?.toString().padStart(2, "0")}</p>}
                <p className="text-[12px] text-[#667085] m-0  !mt-[6px]">Unread Messages</p>
            </div>
        </div>
    )
}

export default DashboardCounts